import React from "react";

/* Shared page masthead for public routes. */
export default function EditorialHero({
  eyebrow,
  titleTop,
  titleItalic,
  description,
  children,
}) {
  return (
    <section className="dept-editorial-hero">
      <div className="dept-editorial-hero__inner">
        {eyebrow && <div className="dept-editorial-hero__eyebrow">{eyebrow}</div>}
        <h1 className="dept-editorial-hero__title">
          {titleTop && <span style={{ display: "block" }}>{titleTop}</span>}
          {titleItalic && <span className="dept-editorial-hero__accent">{titleItalic}</span>}
        </h1>
        {description && <p className="dept-editorial-hero__description">{description}</p>}
        {children && <div style={{ marginTop: 32 }}>{children}</div>}
      </div>
    </section>
  );
}
